<template>
  <div class="feed pb-5">


    <div v-for="card in cards" v-if="filter == card.category || filter == 'today'">

      <!-- everytime a new card.type is created a new FeedcardXxxx also needs to be created and imported-->
      <div :is="'dashboard-feedcard'+ card.type" :cardInfo="card" v-if="card.visible"></div>


    </div>




  </div>
</template>

<script>
  import DashboardFeedcardnews from './FeedcardNews'
  import DashboardFeedcardoccupancy from './FeedcardOccupancy'
  import DashboardFeedcardmulti from './FeedcardMulti'
  import DashboardFeedcarddepartures from './FeedcardDepartures'
  import DashboardFeedcardweather from './FeedcardWeather'
  import DashboardFeedcardoccupancyreport from './FeedcardOccupancyReport'
  import DashboardFeedcardsalesdaily from './FeedcardSalesdaily'
  import DashboardFeedcardmissedcheckins from './FeedcardMissedcheckins'
  import DashboardFeedcardtaskscompleted from './FeedcardTaskscompleted'
  import DashboardFeedcardnewota from './FeedcardNewOTA'

    export default {
      data: function() {
        return {

        }
      },
      created() {
      },
      props:{
        filter:{
          type: String
        },
        cards:{
          type: Array
        }
      },
      components: {
        DashboardFeedcardnews,
        DashboardFeedcardoccupancy,
        DashboardFeedcardmulti,
        DashboardFeedcarddepartures,
        DashboardFeedcardweather,
        DashboardFeedcardoccupancyreport,
        DashboardFeedcardsalesdaily,
        DashboardFeedcardmissedcheckins,
        DashboardFeedcardtaskscompleted,
        DashboardFeedcardnewota
      }
    }
</script>

<style scoped lang="scss">
  @import '../../assets/scss/_variables.scss';

  .feed{
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .feedItem{

      width: 550px;
      height: 300px;
      margin-top: 15px;
      border-color: $medium;
    }
  }

</style>



// WEBPACK FOOTER //
// Feed.vue?74c5c0cb